"use client";

import React, { createContext, useContext, useState, useCallback, useMemo, ReactNode } from "react";

interface ChoicesVisibilityContextValue {
  globalChoicesHidden: boolean;
  toggleGlobalChoicesHidden: () => void;
}

const ChoicesVisibilityContext = createContext<ChoicesVisibilityContextValue | null>(null);

export const useChoicesVisibility = () => {
  return useContext(ChoicesVisibilityContext);
};

interface ChoicesVisibilityProviderProps {
  children: ReactNode;
}

export const ChoicesVisibilityProvider: React.FC<ChoicesVisibilityProviderProps> = ({ children }) => {
  const [globalChoicesHidden, setGlobalChoicesHidden] = useState(false);

  const toggleGlobalChoicesHidden = useCallback(() => {
    setGlobalChoicesHidden(prev => !prev);
  }, []);

  const value = useMemo(() => ({
    globalChoicesHidden,
    toggleGlobalChoicesHidden,
  }), [globalChoicesHidden, toggleGlobalChoicesHidden]);

  return (
    <ChoicesVisibilityContext.Provider value={value}>
      {children}
    </ChoicesVisibilityContext.Provider>
  );
};
